import { render, staticRenderFns } from "./trocar-senha.vue?vue&type=template&id=f2397044"
import script from "./trocar-senha.vue?vue&type=script&lang=js"
export * from "./trocar-senha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports